import React, {useEffect, useState} from "react";
import {useStyles} from "./styles/TopBarStyle";
import {AppBar, Typography, Box, IconButton, Select, MenuItem, FormControl, Button} from "@material-ui/core";
import {openSideWidth, closeSideWidth} from "../../stores/NavigateStore";
import {inject, observer} from "mobx-react";
import {State} from "../../stores/AuthStore";
import {URL_TYPE} from "../../routes/Routes";
import {injectIntl} from "react-intl";
import {ReactComponent as ProfileIcon} from '../../common/images/ProfileIcon.svg';
import {ReactComponent as ArrowDownIcon} from "../../common/images/ArrowDownIcon.svg";
import KoFlag from "../../common/images/KoFlag.png";
import EnFlag from "../../common/images/EnFlag.png";
import {useMediaQuery} from "@material-ui/core";
// import ZhFlag from "../../common/images/ZhFlag.png";
// import JaFlag from "../../common/images/JaFlag.png";
// import ThFlag from "../../common/images/ThFlag.png";
// import ViFlag from "../../common/images/ViFlag.png";
// import MnFlag from "../../common/images/MnFlag.png";
// import IdFlag from "../../common/images/IdFlag.png";
// import RuFlag from "../../common/images/RuFlag.png";
// import TwFlag from "../../common/images/TwFlag.png";

import {useHistory, useLocation} from "react-router-dom";

function TopBar(props) {
    const classes = useStyles();
    const history = useHistory();
    const {contentStore, navigateStore, authStore, localeStore, commonStore} = props;
    const {intl} = props;
    const [titleText, setTitleText] = useState(intl.formatMessage({id: "language_education_app"}));
    const isMobile = useMediaQuery("(max-width: 1000px)");

    const {sideBarOpen} = navigateStore;
    const isLogin = authStore.loginState === State.Authenticated;

    const location = useLocation();
    useEffect(() => {
        const url = location.pathname;

        if (url === URL_TYPE.Login) {
            setTitleText(intl.formatMessage({id: "language_education_app"}));
        } else if (url === URL_TYPE.ContentList) {
            setTitleText(intl.formatMessage({id: "education_contents"}));
        } else if (url.startsWith(URL_TYPE.Content.split(':')[0])) {
            setTitleText(displayContentHeaderText());
        } else if (url === URL_TYPE.MemberManage) {
            setTitleText(intl.formatMessage({id: "member_management"}));
        } else if (url.includes('group')) {
            setTitleText(intl.formatMessage({id: "group_management"}));
        } else if (url === URL_TYPE.MyPage) {
            setTitleText(intl.formatMessage({id: "my_page"}));
        } else if (url === URL_TYPE.Support) {
            setTitleText('');
        } else if (url.includes('statistics')) {
            setTitleText(intl.formatMessage({id: "statistics"}));
        } else if (url.includes('faq')) {
            setTitleText("FAQ");
        } else if (url.includes('notice')) {
            setTitleText(intl.formatMessage({id: "notification_and_event"}));
        } else if (url.includes('push')) {
            setTitleText(intl.formatMessage({id: "push_alarm"}));
        } else {
            setTitleText(intl.formatMessage({id: "language_education_app"}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, localeStore.locale]);


    const displayContentHeaderText = () => {
        return `Step ${contentStore.stepValue}- Day ${contentStore.dayValue}`;
    }

    const handleChangeLanguage = (e) => {
        localeStore.changeLocale(e.target.value)
    }

    const handleClickProfile = () => {
        history.push(URL_TYPE.MyPage);
        commonStore.setSideMenuTab(-1);
    }
    const handleClickTopBarLogo = () => {
        if (location.pathname === URL_TYPE.Support) {
            history.push(URL_TYPE.Login);
        }

    }
    const displayTopBarIcon = () => {
        return (
            <Button disabled={location.pathname !== URL_TYPE.Support} onClick={handleClickTopBarLogo}>
                {pmingIcon}
            </Button>
        )
    }

    return (
        <AppBar
            position="fixed"
            className={classes.appBar}
            style={isMobile ? {width: '100%', top: 0, left: 0} : !isLogin ? {width: '100%'} : sideBarOpen ? {width: `calc(100% - ${openSideWidth}px)`} : {width: `calc(100% - ${closeSideWidth}px)`}}
        >
            <Box sx={{width: '100%'}} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Typography className={classes.title}>
                    <span style={{
                        justifyItems: 'flex-end',
                        alignItems: 'flex-end'
                    }}>{displayTopBarIcon()}</span> {titleText}
                </Typography>
                <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'}>
                    <FormControl className={classes.formControl}>
                        <Select
                            value={localeStore.locale}
                            onChange={handleChangeLanguage}
                            IconComponent={(props) => (
                                <Box>
                                    <ArrowDownIcon  {...props} />
                                </Box>
                            )}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right',
                                },
                                getContentAnchorEl: null,
                                className: classes.selectPopover
                            }}
                            // onBlur={this.handleDomainBoxFocusOut2}
                        >
                            <MenuItem value={'ko'}><img src={KoFlag} alt={'Korean'}
                                                        style={{height: 30}}/>&nbsp;Korean</MenuItem>
                            <MenuItem value={'en'}><img src={EnFlag} alt={'English'} style={{height: 30}}/>&nbsp;English</MenuItem>
                            {/*<MenuItem value={'zh'}><img src={ZhFlag} alt={'Chinese'} style={{height: 30}} />&nbsp;Chinese</MenuItem>*/}
                            {/*<MenuItem value={'ja'}><img src={JaFlag} alt={'Japanese'} style={{height: 30}} />&nbsp;Japanese</MenuItem>*/}
                            {/*<MenuItem value={'th'}><img src={ThFlag} alt={'Thai'} style={{height: 30}} />&nbsp;Thai</MenuItem>*/}
                            {/*<MenuItem value={'vi'}><img src={ViFlag} alt={'Vietnamese'} style={{height: 30}} />&nbsp;Vietnamese</MenuItem>*/}
                            {/*<MenuItem value={'mn'}><img src={MnFlag} alt={'Mongolian'} style={{height: 30}} />&nbsp;Mongolian</MenuItem>*/}
                            {/*<MenuItem value={'id'}><img src={IdFlag} alt={'Indonesian'} style={{height: 30}} />&nbsp;Indonesian</MenuItem>*/}
                            {/*<MenuItem value={'ru'}><img src={RuFlag} alt={'Russian'} style={{height: 30}} />&nbsp;Russian</MenuItem>*/}
                            {/*<MenuItem value={'tw'}><img src={TwFlag} alt={'Taiwanese'} style={{height: 30}} />&nbsp;Taiwanese</MenuItem>*/}
                        </Select>
                    </FormControl>
                    {authStore.loginState === State.Authenticated &&
                        <IconButton className={classes.profileIcon} disableRipple onClick={handleClickProfile}>
                            <ProfileIcon/>
                        </IconButton>
                    }
                </Box>
            </Box>
        </AppBar>
    );
}

export default inject('contentStore', 'navigateStore', 'authStore', 'localeStore', 'commonStore')(injectIntl(observer(TopBar)));

const pmingIcon = <svg width="153" height="28" viewBox="0 0 153 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4474_62998)">
            <path
                d="M81.3984 33.9977V19.7063L74.3661 31.4741H71.8708L64.8952 20.0182V33.9977H59.7344V10.207H64.2997L73.2035 25.0089L81.9655 10.207H86.4741L86.5308 34.0261H81.37L81.3984 33.9977Z"
                fill="#10121C"/>
            <path
                d="M125.206 10.207V34.0261H120.669L108.788 19.5645V34.0261H103.344V10.207H107.909L119.734 24.6686V10.207H125.178H125.206Z"
                fill="#10121C"/>
            <path
                d="M146.956 21.722H151.975V31.3914C149.366 33.3764 145.765 34.4255 142.362 34.4255C134.876 34.4255 129.375 29.2931 129.375 22.119C129.375 14.9449 134.876 9.8125 142.475 9.8125C146.672 9.8125 150.132 11.2303 152.428 13.9241L148.884 17.1851C147.154 15.3419 145.141 14.4912 142.731 14.4912C138.109 14.4912 134.933 17.5821 134.933 22.119C134.933 26.656 138.109 29.7468 142.646 29.7468C144.148 29.7468 145.538 29.4632 146.927 28.726V21.7504L146.956 21.722Z"
                fill="#10121C"/>
            <path d="M92.2344 17.6367H97.7355V34.0265H92.2344V17.6367Z" fill="#10121C"/>
            <path
                d="M94.9837 14.6042C97.2702 14.6042 99.1237 12.7506 99.1237 10.4642C99.1237 8.17775 97.2702 6.32422 94.9837 6.32422C92.6973 6.32422 90.8438 8.17775 90.8438 10.4642C90.8438 12.7506 92.6973 14.6042 94.9837 14.6042Z"
                fill="#4AA45C"/>
            <path
                d="M45.4729 10.207H35.1797V14.6873H45.1894C48.5637 14.6873 50.2651 16.2185 50.2651 18.8273C50.2651 21.436 48.5637 22.9389 45.1894 22.9389H35.1797V33.9977H40.6808V27.4475H45.4729C51.8247 27.4475 55.8229 24.1582 55.8229 18.8556C55.8229 13.553 51.853 10.207 45.4729 10.207Z"
                fill="#10121C"/>
            <path
                d="M26.4448 14.8589C26.4448 8.64894 21.3975 3.60156 15.1875 3.60156V26.1446C21.3975 26.1446 26.4448 21.0972 26.4448 14.8873V14.8589Z"
                fill="#4AA45C"/>
            <path
                d="M0.1875 25.4341C0.1875 31.6441 5.23487 36.6915 11.4448 36.6915V14.1484C5.23487 14.1484 0.1875 19.1958 0.1875 25.4058V25.4341Z"
                fill="#4AA45C"/>
            <path
                d="M5.83035 11.2857C8.94681 11.2857 11.4732 8.75931 11.4732 5.64285C11.4732 2.52639 8.94681 0 5.83035 0C2.71389 0 0.1875 2.52639 0.1875 5.64285C0.1875 8.75931 2.71389 11.2857 5.83035 11.2857Z"
                fill="#F6D046"/>
        </g>
        <defs>
            <clipPath id="clip0_4474_62998">
                <rect width="152.244" height="36.6927" fill="white" transform="translate(0.1875)"/>
            </clipPath>
        </defs>
    </svg>
;
